import { render, staticRenderFns } from "./authFaceResult.vue?vue&type=template&id=c33b9be4&scoped=true"
import script from "./authFaceResult.vue?vue&type=script&lang=js"
export * from "./authFaceResult.vue?vue&type=script&lang=js"
import style0 from "./authFaceResult.vue?vue&type=style&index=0&id=c33b9be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b9be4",
  null
  
)

export default component.exports